<template>
	<div class="">
		<Step></Step>
		<router-link :to="{name: 'set_up_under18'}" class="start-button layout-row layout-hv-center color-white bg-pink1 pointer" v-if="storyList.total == 0">
			<font-awesome-icon class="plus-circle" icon="plus-circle" />開始報名！
		</router-link>
		<TeamList class="team-list" v-if="storyList.total" @createTeam="dialogVisible = true"></TeamList>

		<el-dialog :visible.sync="dialogVisible" top="40vh" class="create-dialod">
			<div class="story-type">
				<router-link :to="{name: 'set_up_under18'}">
					<div class="button-tp link-btn color-white bg-green1">
						輔導員<br />你帶領的所有成員皆未滿18歲</div>
				</router-link>
				<router-link :to="{name: 'set_up_upper18'}">
					<div class="button-tp link-btn color-white bg-blue1">挑戰者<br />所有成員皆滿18歲</div>
				</router-link>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Step from "@/components/challenge/signUp/Step";
import TeamList from "@/components/challenge/signUp/TeamList";
import { mapActions, mapState } from "vuex";

export default {
	data() {
		return {
			dialogVisible: false,
		};
	},
	computed: {
		...mapState("story", ["storyList"])
	},
	methods: {
		...mapActions("story", ["getPersonStoryList"]),
		async init() {
			let query = this.$route.query;
			await this.getPersonStoryList({
				page: Number(query.page) || 1,
				size: Number(query.size) || 10
			});
		}
	},
	created() {
		this.init();
	},
	mounted() { },
	components: {
		Step,
		TeamList
	}
};
</script>

<style lang="scss" scoped>
.start-button {
	height: 60px;
	border-radius: 5px;
	margin-top: 30px;
	margin-bottom: 130px;
	// background: #c8c9cc;
	// cursor: not-allowed;

	.plus-circle {
		margin-right: 7px;
	}
}

.team-list {
	margin-top: 20px;
}
.story-type {
	display: flex;
	flex-direction: row;
	justify-content: space-around;

	.link-btn {
		width: 20vw;
		height: 20vw;
		max-width: 260px;
		max-height: 260px;
		font-size: 24px;
		text-align: center;
		padding: 15px;
	}
}

.create-dialod {
	a {
		text-decoration: none;
	}
}

@media only screen and (max-width: 1100px) {
	.story-type {
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.link-btn {
			width: 200px;
			height: 200px;
			font-size: 18px;
			margin-bottom: 30px;
		}
	}
}
</style>